document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger);

  let mmColumns = gsap.matchMedia();

  if (document.querySelector("main.scrolled")) {
    const mainScrolled = document.querySelector("main.scrolled");
    const scrollTitles = document.querySelector(".scroll-titles");
    const scrollCursors = document.querySelector(".scroll-cursors");

    if (mainScrolled && scrollTitles) {
      const syncScroll = () => {
        scrollTitles.scrollLeft = mainScrolled.scrollTop;
        if (scrollCursors) {
          scrollCursors.scrollLeft = mainScrolled.scrollTop;
        }
      };
      mainScrolled.addEventListener("scroll", syncScroll);
      syncScroll();
    } 

    const sections = document.querySelectorAll(".horizontal-scroll__section");
    let currentHoveredSection = null;

    const globalCursorLink = document.createElement("div");
    globalCursorLink.classList.add("cursor-link");
    document.body.appendChild(globalCursorLink);

    const globalCursorLinkAnchor = document.createElement("a");
    globalCursorLink.appendChild(globalCursorLinkAnchor);

    globalCursorLink.style.opacity = 0;
    globalCursorLink.style.pointerEvents = "none";
    globalCursorLinkAnchor.style.pointerEvents = "none";

    let mouseMoveRAFId = null;

    sections.forEach((section) => {
      section.addEventListener("mouseenter", (e) => {
        currentHoveredSection = section;

        globalCursorLink.style.opacity = 1;

        globalCursorLinkAnchor.href = section.dataset.link;
        globalCursorLinkAnchor.textContent = `Explore ${section.dataset.title}`;

        globalCursorLink.style.left = `${e.clientX}px`;
        globalCursorLink.style.top = `${e.clientY}px`;
      });

      section.addEventListener("mouseleave", () => {
        currentHoveredSection = null;

        globalCursorLink.style.opacity = 0;
        globalCursorLinkAnchor.style.pointerEvents = "none";

        if (mouseMoveRAFId) {
          cancelAnimationFrame(mouseMoveRAFId);
          mouseMoveRAFId = null;
        }
      });
    });

    document.addEventListener("mousemove", (e) => {
      if (currentHoveredSection) {
        if (mouseMoveRAFId) {
          cancelAnimationFrame(mouseMoveRAFId);
        }
        mouseMoveRAFId = requestAnimationFrame(() => {
          globalCursorLink.style.left = `${e.clientX}px`;
          globalCursorLink.style.top = `${e.clientY}px`;

          mouseMoveRAFId = null;
        });
      }
    });

    mainScrolled.addEventListener("mouseleave", () => {
      if (currentHoveredSection) {
        currentHoveredSection = null;
        globalCursorLink.style.opacity = 0;
        globalCursorLinkAnchor.style.pointerEvents = "none";

        if (mouseMoveRAFId) {
          cancelAnimationFrame(mouseMoveRAFId);
          mouseMoveRAFId = null;
        }
      }
    });
  }
  if (document.querySelector(".horizontal-scroll__screen")) {
    let hmColumns = gsap.matchMedia();
    hmColumns.add("(max-width: 767px)", () => {
      document
        .querySelectorAll(".horizontal-scroll__screen")
        .forEach((section, index) => {
          const eachTitle = section.querySelector("h2");

          ScrollTrigger.create({
            trigger: eachTitle,
            pin: true,
            start: "top top",
            end: () => {
              const visibleHeight = window.innerHeight;
              return `+=${visibleHeight * 0.8}`;
            },
            // pinType: "transform",
            pinType: "fixed",
            anticipatePin: 1,
            scroller: window,
          });
        });
    });
  }



const isFirefox = navigator.userAgent && /Firefox\/\d+/.test(navigator.userAgent);
if (isFirefox) {
  const mainScrolled = document.querySelector("main.scrolled");
    const scrollTitles = document.querySelector(".scroll-titles");
    const scrollCursors = document.querySelector(".scroll-cursors");

const wheelToPx = (e, baseEl) => {
  let d = e.deltaY !== 0 ? e.deltaY : (e.deltaX || 0);
  if (e.deltaMode === 1) d *= 16;                        
  else if (e.deltaMode === 2) d *= baseEl.clientHeight; 
  return d;
};

(() => {
  
  const REGION = "main.scrolled, .scroll-titles, .scroll-cursors, .horizontal-scroll__section";

  const onWheelToMain = (e) => {
    const within = e.target.closest(REGION);
    if (!within) return;                

    const dy = wheelToPx(e, within);
    if (!dy) return;

    e.preventDefault();                
  
    const maxY = mainScrolled.scrollHeight - mainScrolled.clientHeight;
    const next = Math.max(0, Math.min(mainScrolled.scrollTop + dy, maxY));
    if (next !== mainScrolled.scrollTop) mainScrolled.scrollTop = next;
  };


  window.addEventListener("wheel", onWheelToMain, { passive: false, capture: true });
})();
if (document.querySelector("main.scrolled")) {
const spacer = document.querySelector("main.scrolled .scrolled__spacer") 
              || mainScrolled.appendChild(Object.assign(document.createElement("div"), { className: "scrolled__spacer" }));

  const ensureHeight = () => {
    const maxX = Math.max(
      (scrollTitles.scrollWidth  - scrollTitles.clientWidth)  || 0,
      (scrollCursors?.scrollWidth - scrollCursors?.clientWidth) || 0
    );
   
    spacer.style.height = (maxX + mainScrolled.clientHeight) + "px";
  };

  ensureHeight();
  window.addEventListener("resize", ensureHeight, { passive: true });
}
}
  if (document.querySelector(".colorway-slider__content")) {
    ScrollTrigger.create({
      trigger: ".colorway-slider-wrapper",
      start: "top top",
      end: () =>
        "+=" +
        document.querySelector(".colorway-slider__content").offsetHeight +
        "px",
      pin: ".colorways-video-slider",
      pinSpacing: false,
      scrub: true,
    });
  }
  if (document.querySelector(".artisanal-text-parallax")) {
    ScrollTrigger.create({
      trigger: ".artisanal-text-parallax",
      start: "top top",
      end: "bottom bottom",
      pin: ".artisanal-text-parallax__content",
      pinSpacing: false,
      scrub: true,
    });
  }
   const wraps = document.querySelectorAll('.totem-row-wrap');
     wraps.forEach(function(wrap, index) {
        if (index === wraps.length - 1) return;
        ScrollTrigger.create({
          trigger: wrap,
          start: 'top top',
          end: 'bottom top',
          pin: true,
          pinSpacing: false,
          scrub: true,
        });
      });

    document.querySelectorAll('.totem-carousel__link').forEach(anchor => {
  anchor.addEventListener('click', function (e) {

    try {
      const url = new URL(this.href, window.location.origin);

      if (url.pathname === window.location.pathname && url.hash) {
        e.preventDefault();

        const targetId = url.hash;
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          const st = ScrollTrigger.getAll().find(
            instance => instance.trigger === targetElement
          );

          if (st) {
            gsap.to(window, {
              duration: 1,
              scrollTo: st.start,
              ease: "power2.inOut"
            });
          } else {
            gsap.to(window, {
              duration: 1,
              scrollTo: targetElement,
              ease: "power2.inOut"
            });
          }
          if (window.history && window.history.replaceState) {
            window.history.replaceState(
              null,
              "",
              window.location.pathname + window.location.search
            );
          }
        }
      }
    } catch (err) {
     
    }
  });
});

  if (document.querySelector(".artisanal-images4-parallax-row")) {
    const tl4high = gsap.timeline({
      scrollTrigger: {
        trigger: ".artisanal-images4-parallax-row",
        start: "top bottom",
        end: "bottom 30%",
        scrub: true,
      },
    });

    tl4high.to(".images4-parallax-1 img", { yPercent: 50 }, 0);
    tl4high.to(".images4-parallax-3 img", { yPercent: 50 }, 0);
    tl4high.to(".images4-parallax-2 img", { y: -500 }, 0);
    tl4high.to(".images4-parallax-4 img", { y: -500 }, 0);
  }

  mmColumns.add("(min-width: 768px)", () => {
    if (document.querySelector(".client-service.contact-sidebar")) {
      ScrollTrigger.create({
        trigger: ".contact__main",
        start: "top-=176 top",
        endTrigger: ".collection-bottom-banner",
        end: "top 50%",
        pin: ".contact__sidebar",
        scrub: true,
        pinSpacing: false,
        onLeave: () => {
          document.querySelector(".contact-sidebar").classList.add("pp-hidden");
        },
        onEnterBack: () => {
          document
            .querySelector(".contact-sidebar")
            .classList.remove("pp-hidden");
        },
      });
    }
    if (document.querySelector(".art-wrapping.contact-sidebar")) {
      ScrollTrigger.create({
        trigger: ".contact__main",
        start: "top-=176 top",
        endTrigger: ".art-silk-wrap",
        end: "top 60%",
        pin: ".contact__sidebar",
        scrub: true,
        pinSpacing: false,
        markers:true,
        onLeave: () => {
          document.querySelector(".contact-sidebar").classList.add("pp-hidden");
        },
        onEnterBack: () => {
          document
            .querySelector(".contact-sidebar")
            .classList.remove("pp-hidden");
        },
      });
    }
  });
  if (document.querySelector(".artisanal-triple-parallax")) {
    mmColumns.add("(min-width: 1033px)", () => {
      const details = gsap.utils.toArray(
        ".artisanal-triple-parallax__section--image:not(:first-child)"
      );
      const photos = gsap.utils.toArray(
        ".artisanal-triple-parallax__section--text:not(:first-child)"
      );
      gsap.set(photos, { yPercent: 100 });
      const animation = gsap.to(photos, {
        yPercent: 0,
        duration: 1,
        stagger: 1,
      });
      ScrollTrigger.create({
        trigger: ".artisanal-triple-parallax",
        start: "top top",
        end: "bottom bottom",
        pin: ".artisanal-triple-parallax__section--left",
        animation: animation,
        scrub: true,
      });
    });
  }

  if (document.querySelector(".artisanal-product-parallax__content")) {
    mmColumns.add("(min-width: 768px)", () => {
      ScrollTrigger.create({
        trigger: ".artisanal-product-parallax__content",
        start: "top top",
        end: "bottom bottom",
        pin: ".artisanal-product-parallax__content",
        pinSpacing: false,
        onLeave: () => {
          document
            .querySelector(".artisanal-product-parallax")
            .classList.add("pp-hidden");
        },
        onEnterBack: () => {
          document
            .querySelector(".artisanal-product-parallax")
            .classList.remove("pp-hidden");
        },
      });
    });
  }
  const section = document.querySelector(".artisanal-inner-columns-2");
  if (section) {
    const content = section.querySelector(
      ".artisanal-inner-columns-2__content"
    );

    gsap.to(content, {
      y: "-100%",
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: section.querySelector(".artisanal-inner-columns-2__image-wrap"),
        anticipatePin: 1,
      },
    });
  }
  mmColumns.add("(min-width: 769px)", () => {
    if (document.querySelector(".parallax-slider-background")) {
      if (document.querySelector(".parallax-wrapper")) {
        ScrollTrigger.create({
          trigger: ".parallax-wrapper",
          start: "top top",
          end: "bottom bottom",
          pin: ".parallax-slider-background",
          pinSpacing: false,
          scrub: true,
          markers: true,
        });
      }
    }
    if (document.querySelector(".fixed-background")) {
      ScrollTrigger.create({
        trigger: ".parallax-section__content",
        start: "top top",
        endTrigger: ".collection-bottom-banner",
        end: "bottom bottom",
        pin: ".fixed-background",
        pinSpacing: false,
        anticipatePin: 1,
        scrub: true,
        markers: true,
      });
    }
  });
  if (document.querySelector(".fixed-video")) {
    ScrollTrigger.create({
      trigger: ".parallax-section__content",
      start: "top top",
      endTrigger: ".collection-bottom-banner",
      end: "bottom bottom",
      pin: ".fixed-video",
      pinSpacing: false,
      anticipatePin: 1,
      scrub: true,
      markers: true,
    });
  }
  const firstSection = document.querySelectorAll(
    "main.index-main .shopify-section"
  )[0];

  const secondSection = document.querySelectorAll(
    "main.index-main .shopify-section"
  )[1];

  const fourthSection = document.querySelectorAll(
    "main.index-main .shopify-section"
  )[3];

  const sixthSection = document.querySelector(".sticky-video-wrap");
  if (document.querySelector(".sticky-video__content")) {
    const textElement = sixthSection.querySelector(".sticky-video__content");
  }

  function disableScrolling() {
    document.body.style.overflow = "hidden";
  }

  function enableScrolling() {
    document.body.style.overflow = "";
  }
});
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollToPlugin);

  const sections = document.querySelectorAll("main .shopify-section");
  const totalSections = sections.length;
  let currentIndex = 0;

  let mm = gsap.matchMedia();
  mm.add("(min-width: 1440px)", () => {
    if (document.querySelector(".scroll-container")) {
      const scrollContainer = document.querySelector(".scroll-container");
      const column1 = document.querySelector(".column-1");
      gsap.to(column1, {
        y: -250,
        ease: "power1.out",
        scrollTrigger: {
          trigger: scrollContainer,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
      const column3 = document.querySelector(".column-3");
      gsap.to(column3, {
        y: 1000,
        ease: "power1.out",
        scrollTrigger: {
          trigger: scrollContainer,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
    }
  });
  mm.add("(min-width: 769px) and (max-width: 1439px", () => {
    if (document.querySelector(".scroll-container")) {
      const scrollContainer = document.querySelector(".scroll-container");
      const column1 = document.querySelector(".column-1");
      gsap.to(column1, {
        y: -350,
        ease: "power1.out",
        scrollTrigger: {
          trigger: scrollContainer,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
      const column3 = document.querySelector(".column-3");
      gsap.to(column3, {
        y: 1000,
        ease: "power1.out",
        scrollTrigger: {
          trigger: scrollContainer,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
    }
  });

  document.querySelectorAll(".one-full-col__bg").forEach((bg, index) => {
  if (bg.parentElement?.classList.contains("one-full-video-column")) return;

  const eachTitle = bg.nextElementSibling;
  const isDesktopTitle = window.innerWidth > 768;
  let mm = gsap.matchMedia();
  mm.add("(min-width: 769px)", () => {
    gsap.to(bg, {
      y: "-25%",
      ease: "none",
      scrollTrigger: {
        trigger: bg.parentElement,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });

    gsap.fromTo(
      bg,
      { scale: 1.1 },
      {
        scale: 1,
        ease: "power1.in",
        duration: 3.5,
        scrollTrigger: {
          trigger: bg.parentElement,
          start: "top 70%",
          end: "bottom top",
          toggleActions: "play none none none",
          once: true,
        },
      },
    );

    ScrollTrigger.create({
      trigger: eachTitle,
      pin: true,
      start: "top top",
      end: () => {
        const visibleHeight = window.innerHeight;
        return `+=${visibleHeight * 0.8}`;
      },
      pinType: "transform",
      anticipatePin: 1,
      scroller: window,
    });
  });
});


  const ravensBg = document.querySelector(".two-cols__video .one-full-col__video-wrap ");

  const sliderTitles = document.querySelectorAll(
    ".two-cols__slider h2"
  );
  const isRavenDesktopTitle = window.innerWidth > 768;

  if (isRavenDesktopTitle) {
    sliderTitles.forEach((slideTitle) => {
      ScrollTrigger.create({
        trigger: slideTitle,
        pin: true,
        start: "top top",
        end: () => {
          const visibleHeight = window.innerHeight;
          return `+=${visibleHeight * 0.8}`;
        },
        pinType: "transform",
        anticipatePin: 1,
        scroller: window,
      });
    });
  }
  mm.add("(min-width: 769px)", () => {
  if (ravensBg) {
    
    const ravenTitle = ravensBg.nextElementSibling;
    gsap.to(ravensBg, {
      y: "-25%",
      ease: "none",
      scrollTrigger: {
        trigger: ravensBg.parentElement,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      });
    

    gsap.fromTo(
      ravensBg,
      { scale: 1.1 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: ravensBg.parentElement,
          start: "top 70%",
          end: "bottom bottom",
          toggleActions: "play none none none",
          once: true,
        },
      }
    );
    

    if (ravenTitle && isRavenDesktopTitle) {
      ScrollTrigger.create({
        trigger: ravenTitle,
        pin: true,
        start: "top top",
        end: () => {
          const visibleHeight = window.innerHeight;
          return `+=${visibleHeight * 0.8}`;
        },
        pinType: "transform",
  
        anticipatePin: 1,
        scroller: window,
      });
    }
  }
  });

  const introText = document.querySelector(".scroll-reveal");
  const inMobile = window.innerWidth < 768;
  let hasAnimated = false;
  let touchStartY = 0;

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function animateIntroOut() {
    hasAnimated = true;
    gsap.to(introText, {
      scale: 0.5,
      opacity: 0,
      duration: 0.5,
      ease: "power2.out",
      onComplete: () => {
        document.body.style.overflow = "";
        document.body.style.height = "";
        removeListeners();
      },
    });
  }

  function onWheel(e) {
    if (!hasAnimated && e.deltaY > 0) {
      e.preventDefault();
      animateIntroOut();
    }
  }

  function onTouchStart(e) {
    if (e.touches.length === 1) {
      touchStartY = e.touches[0].clientY;
    }
  }

  function onTouchEnd(e) {
    introText.classList.add("hidden");
    if (!hasAnimated && touchStartY) {
      const touchEndY = e.changedTouches[0].clientY;
      const deltaY = touchStartY - touchEndY;

      if (deltaY > 30) {
        animateIntroOut();
      }
    }
  }

  function resetIntro() {
    if (!inMobile) {
      gsap.to(introText, {
        scale: 1,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        onComplete: () => {
          hasAnimated = false;
          document.body.style.overflow = "hidden";
          document.body.style.height = "100vh";
          addListeners();
        },
      });
    } else {
    }
  }

  function addListeners() {
    removeListeners();
    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("touchstart", onTouchStart, { passive: false });
    window.addEventListener("touchend", onTouchEnd, { passive: false });
  }

  function removeListeners() {
    window.removeEventListener("wheel", onWheel);
    window.removeEventListener("touchstart", onTouchStart);
    window.removeEventListener("touchend", onTouchEnd);
  }

  function checkAndActivateIntro() {
    if (!inMobile) {
      if (introText && isInViewport(introText) && !hasAnimated) {
        addListeners();

        window.removeEventListener("scroll", checkAndActivateIntro);
      }
    }
  }

  if (introText) {
    const width = window.innerWidth;

    if (isInViewport(introText)) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
      addListeners();
    } else {
      window.addEventListener("scroll", checkAndActivateIntro);
    }

    const sections = [
      ".artisanal-top-section",
      ".parallax-section__content--row:first-of-type",
      ".artisanal-inner-top-video-section",
      ".colorways-top",
      ".totem-circle",
      "totem-top-bg-section"
    ];

    sections.forEach((selector) => {
      const el = document.querySelector(selector);
      const width = window.innerWidth;

      if (el) {
        gsap.timeline({
          scrollTrigger: {
            trigger: selector,
            start: "top top",
            end: "bottom 80%",
            scrub: true,
            onEnterBack: resetIntro,
          },
        });
      }
    });
  }

      if(document.querySelector('.section-totem-carousel')) {
 const carousel = document.querySelector('.section-totem-carousel');
      const footerEl = document.querySelector('.footer');
      if (footerEl) {
        ScrollTrigger.create({
          trigger: footerEl,
          start: 'top bottom-=76px',
          onEnter: function() {
            carousel.classList.add('no-fixed');
          },
          onLeaveBack: function() {
            carousel.classList.remove('no-fixed');
          }
        });
      }
    }
  

  ScrollTrigger.refresh();
});
